import LoginBtn from './LoginBtn'
import LanguageBtn from './LanguageBtn'
import './Header.css'
import logo from './img/logo.png'
const Header = ({signStatus, getLanguage}) => {
  return (
    <div className="main-navbar">         
      <h1 className='main-title'>
        <img src={logo} alt="Логотип" className="main-logo" />
        {/* LOW COST TV */}
      </h1>
      <div className="nav-actions">
        <LanguageBtn getLanguage={getLanguage}/>
        <LoginBtn signStatus={signStatus}/>
      </div>
    </div>
  );
};
export default Header;